<template>
  <v-dialog
    max-width="636"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :value="dialog"
    @input="$store.commit('orders/CLOSE_PAYMENT_DIALOG')"
  >
    <v-card class="px-7" height="720px">
      <v-row no-gutters class="pb-6 px-2 py-10">
        <v-col>
          <div class="font-size-lg-res font-weight-semibold">
            Add Payment Method
          </div>
        </v-col>
        <v-col>
          <CloseDialogButton
            :close="() => $store.commit('orders/CLOSE_PAYMENT_DIALOG')"
          />
        </v-col>
      </v-row>
      <v-row no-gutters class="pb-6 px-2 py-10">
        <v-col>
          <Stripe />
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";
import Stripe from "@/components/Payment/Stripe.vue";

export default {
  name: "OrderPaymentDialog",
  components: {
    CloseDialogButton,
    Stripe,
  },
  computed: {
    ...mapState({
      dialog: (state) => state.orders.dialog.payment,
    }),
  },
};
</script>
